import React from 'react'

import style from './style.css'

export default props => (
    <div className={`${style.alert} ${style[props.type] || ''}`}>
        {props.message}
        {props.children}
    </div>
)


// WEBPACK FOOTER //
// ./src/SPRINTA/atoms/Alert/index.js